import { ZodError } from 'zod';
import { isApiValidationError422 } from '@repo/api/helpers';
import { FetchError } from '@repo/api/client';
import { merchantSchema } from './merchant.schema';
export var getQueryData = function (merchantQueryData) {
    var fetchError = merchantQueryData && FetchError.getFetchError(merchantQueryData.error);
    if (fetchError && isApiValidationError422(fetchError)) {
        try {
            return merchantSchema.parse(fetchError.data);
        }
        catch (error) {
            if (error instanceof ZodError) {
                var list = error.issues.map(function (i) { return ({
                    path: i.path.join('.'),
                    message: i.message,
                    code: i.code,
                }); });
                console.error('Validation error:', list);
                return 'RESPONSE_422_VALIDATION_ERROR';
            }
            console.error('Unexpected error:', error);
            return undefined;
        }
    }
    return merchantQueryData === null || merchantQueryData === void 0 ? void 0 : merchantQueryData.data;
};
export var isUnhandledErrorQuery = function (merchantQueryData) {
    return (merchantQueryData &&
        merchantQueryData.status === 'error' &&
        merchantQueryData.error &&
        !isApiValidationError422(merchantQueryData.error));
};
